<template>
    <div class="appwrap">
      <div  uk-sticky="" class="nav-wrapper">
        <div>
          <div uk-sticky="" class="nav-wrapper">
            <!--  TOP NAV -->
            <section class="uk-section uk-padding-remove-vertical uk-margin-small-bottom topnav">
              <div class="uk-container uk-container-xsmall headwrap  uk-padding-remove-horizontal">
                <div class="uk-navbar-container tm-navbar-container uk-sticky" style="">
                  <div class="uk-container">
                    <div uk-grid class="uk-flex uk-flex-middle">
                      <div class="uk-width-1-5 uk-text-center">
<!--                        <a href="javascript:history.go(-1)" uk-icon="icon: chevron-left; ratio: 1.6"></a>-->
                      </div>
                      <div class="uk-width-3-5 uk-text-center">
                        <router-link to="/">
                          <img :src="getImage('app-header-logo.png')" alt="Logo" width="250" height="34">
                        </router-link>
                      </div>
                      <div class="uk-width-1-5 uk-text-center">
                  <span class="uk-icon" uk-icon="icon: more-vertical; ratio: 1.3"
                        uk-toggle="target: #offcanvas-nav"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <!--  // TOP NAV -->
          </div>
          <!--<div class="uk-sticky-placeholder" style="height: 85px; margin: 0px;"></div>-->
        </div>
        <TopSearch />
        <ListingBar v-bind:views="views" />
      </div>
        <slot />
<!--        <BottomNav />-->
        <OffCanvasMenu />
      <div ref="offcanvas"></div>
      <div id="ss-modal-center" class="uk-flex-top" uk-modal>`
        <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
          <button class="uk-modal-close-default" type="button" uk-close></button>
          <div id="stamp-title">{{ $t("StampTheScreen") }}</div>
          <div @touchstart="onTouchStartStamp" @touchstart.native="onTouchStartStamp"
               id="stamp-area">
            <div id="stamp-general-modal-img" :style="{ 'backgroundImage': 'url(\'' + bgImg + '\')' }"></div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import TopNav from '../components/TopNav.vue'
import TopSearch from '../components/TopSearch'
import ListingBar from '../components/ListingNavBar'
import BottomNav from '../components/BottomNav'
import OffCanvasMenu from '../components/OffCanvasMenu'
// import SnowShoeStamp from '../components/SnowShoeStamp'

const searchBarDefault = true
const listingBarDefault = false
export default {
  data () {
    return {
      views: 'list',
      bgImg: require('../assets/images/stamp/stamp_hands_black.png')
    }
  },
  computed: {
    searchBar () {
      if (this.$route.meta.searchbar !== '') {
        return this.$route.meta.searchbar
      } else {
        return searchBarDefault
      }
    },
    listingBar () {
      if (this.$route.meta.listingbar !== '') {
        return this.$route.meta.listingbar
      } else {
        return listingBarDefault
      }
    }
  },
  components: {
    TopNav,
    TopSearch,
    ListingBar,
    BottomNav,
    OffCanvasMenu
    // SnowShoeStamp

  }
}
</script>
<style scoped lang="less">
  .uk-modal-body{
    padding: 0 !important;
  }
  #stamp-area{
    height: 75vh;
  }
  #stamp-title{
    text-align: center;
    font-size: 1.7em;
    padding: 30px 0 0 10px;
  }
  #stamp-general-modal-img {
    background-position: top;
    background-repeat: no-repeat;
    height: 100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/Merchant.vue